import React from 'react';

import {
    ModalContentErrors,
    ModalContentErrorItem,
    ModalContentErrorItemIndex,
    ModalContentErrorItemErrors,
} from '../styled';

interface InvalidRowsProps {
    invalidRows: {
        rows: [
            string,
            {
                error: string[];
            },
        ][];
        fullLength: number;
    };
    t: (key: string) => string;
    GEN_INFO: string;
}
export const InvalidRows = ({invalidRows, t, GEN_INFO}: InvalidRowsProps) => (
    <ModalContentErrors>
        {invalidRows.rows.map(([index, row]) => (
            <ModalContentErrorItem key={index}>
                <ModalContentErrorItemIndex>
                    {t(`${GEN_INFO}.rows`)} {Number(index)}:
                </ModalContentErrorItemIndex>
                <ModalContentErrorItemErrors>
                    {row.error.map((error) => (
                        <div key={error}>{error}</div>
                    ))}
                </ModalContentErrorItemErrors>
            </ModalContentErrorItem>
        ))}
    </ModalContentErrors>
);
